// 기본 컬러 팔레트
export const colors = {
    // Primary Blue - 메인 브랜드 컬러
    primary: {
        main: '#002755', // 메인 블루
        light: '#1a4a7a', // 밝은 블루
        dark: '#001a3a', // 어두운 블루
        contrast: '#ffffff', // 대비 컬러 (흰색)
    },

    // Secondary Green - 보조 컬러
    secondary: {
        main: '#4CAF50', // 메인 그린
        light: '#66BB6A', // 밝은 그린
        dark: '#388E3C', // 어두운 그린
        contrast: '#ffffff', // 대비 컬러
    },

    // Accent Orange - 강조 컬러
    accent: {
        main: '#FF9800', // 메인 오렌지
        light: '#FFB74D', // 밝은 오렌지
        dark: '#F57C00', // 어두운 오렌지
        contrast: '#ffffff', // 대비 컬러
    },

    // Neutral Gray - 중성 컬러
    neutral: {
        main: '#9E9E9E', // 메인 그레이
        light: '#E0E0E0', // 밝은 그레이
        dark: '#616161', // 어두운 그레이
        contrast: '#ffffff', // 대비 컬러
    },

    // Navigation Colors - 네비게이션 버튼 전용 컬러
    navigation: {
        gallery: {
            main: '#8E24AA', // 보라색 - 갤러리
            light: '#BA68C8',
            dark: '#6A1B9A',
            contrast: '#ffffff',
        },
        map: {
            main: '#1976D2', // 파란색 - 지도
            light: '#42A5F5',
            dark: '#1565C0',
            contrast: '#ffffff',
        },
        lab1: {
            main: '#D32F2F', // 빨간색 - 실험실 1
            light: '#EF5350',
            dark: '#C62828',
            contrast: '#ffffff',
        },
        lab2: {
            main: '#388E3C', // 초록색 - 실험실 2
            light: '#66BB6A',
            dark: '#2E7D32',
            contrast: '#ffffff',
        },
        address: {
            main: '#FF6F00', // 주황색 - 주소찾기
            light: '#FF8A65',
            dark: '#E65100',
            contrast: '#ffffff',
        },
    },

    // Semantic Colors - 의미론적 컬러
    semantic: {
        success: '#4CAF50', // 성공
        warning: '#FF9800', // 경고
        error: '#F44336', // 에러
        info: '#2196F3', // 정보
        white: '#ffffff', // 흰색
        black: '#000000', // 검정색
    },
};

// 그라데이션 컬러 조합
export const gradients = {
    primaryGradient: 'linear-gradient(135deg, #002755 0%, #1a4a7a 100%)',
    secondaryGradient: 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)',
    accentGradient: 'linear-gradient(135deg, #FF9800 0%, #FFB74D 100%)',
    neutralGradient: 'linear-gradient(135deg, #9E9E9E 0%, #E0E0E0 100%)',
};

// 투명도 변형
export const alpha = {
    light: 0.1, // 매우 연한 투명도
    medium: 0.5, // 중간 투명도
    heavy: 0.8, // 강한 투명도
};

// 컬러 유틸리티 함수
export const colorUtils = {
    // 투명도 적용 함수
    withAlpha: (color, alpha) => {
        // hex 컬러를 rgba로 변환
        const hex = color.replace('#', '');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },

    // 밝기 조절 함수
    lighten: (color, percent) => {
        const hex = color.replace('#', '');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);

        const factor = 1 + percent / 100;
        const newR = Math.min(255, Math.round(r * factor));
        const newG = Math.min(255, Math.round(g * factor));
        const newB = Math.min(255, Math.round(b * factor));

        return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB
            .toString(16)
            .padStart(2, '0')}`;
    },

    // 어둡게 조절 함수
    darken: (color, percent) => {
        const hex = color.replace('#', '');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);

        const factor = 1 - percent / 100;
        const newR = Math.max(0, Math.round(r * factor));
        const newG = Math.max(0, Math.round(g * factor));
        const newB = Math.max(0, Math.round(b * factor));

        return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB
            .toString(16)
            .padStart(2, '0')}`;
    },
};

export default colors;
